// extracted by mini-css-extract-plugin
export default {"title":"Title_title__VCqX9","bold":"Title_bold__vRCfo"};